module.exports = __webpack_public_path__ + "static/media/APY.b9727a8a.svg";